jQuery(document).ready(function($) {
	$("#shopify-section-16378582766d974be7").addClass("show");
    $("#shipping-close").on('click',function(e){
      e.preventDefault();
      $("#shopify-section-16378582766d974be7").removeClass("show");
    })
                           
});